module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C143_12"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("CONTENTS")])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('p', {
    staticClass: "C144"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/06_1__First#page_1"
    }
  }, [_c('em', [_vm._v("Chapter 1")]), _vm._v(". FIRST IMPRESSIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "C144"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_2__Probi#page_20"
    }
  }, [_c('em', [_vm._v("Chapter 2")]), _vm._v(". PROBINGS")])]), _vm._v(" "), _c('p', {
    staticClass: "C144"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_3__Arab#page_37",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chapter 3")]), _vm._v(". ARAB AFFAIRS ANALYST OF SORTS")])]), _vm._v(" "), _c('p', {
    staticClass: "C144"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_4__Rache#page_49",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chapter 4")]), _vm._v(". RACHEL")])]), _vm._v(" "), _c('p', {
    staticClass: "C144"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_5__The_L#page_68",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chapter 5")]), _vm._v(". THE LEVANTINISM SCARE")])]), _vm._v(" "), _c('p', {
    staticClass: "C144"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_6__The_T#page_91",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chapter 6")]), _vm._v(". THE THREE DIVIDES")])]), _vm._v(" "), _c('p', {
    staticClass: "C144"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_7__Barba#page_111",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chapter 7")]), _vm._v(". BARBARIANS AT THE GATE")])]), _vm._v(" "), _c('p', {
    staticClass: "C144"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_8__Gentl#page_137",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chapter 8")]), _vm._v(". GENTLEFOLK AND UPSTARTS")])]), _vm._v(" "), _c('p', {
    staticClass: "C144"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_9__Israe#page_157",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chapter 9")]), _vm._v(". ISRAEL’S COMMUNAL PROBLEM")])]), _vm._v(" "), _c('p', {
    staticClass: "C144"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_10__Free#page_173",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chapter 10")]), _vm._v(". FREEDOM OF SPEECH, ISRAEL STYLE")])]), _vm._v(" "), _c('p', {
    staticClass: "C144"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_11__The#page_190",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chapter 11")]), _vm._v(". THE MYSTERY OF EDUCATION")])]), _vm._v(" "), _c('p', {
    staticClass: "C144"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_12__The#page_202",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chapter 12")]), _vm._v(". THE DEBATE INTENSIFIES")])]), _vm._v(" "), _c('p', {
    staticClass: "C824"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_13__Step#page_219",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chapter 13")]), _vm._v(". STEPPING ON “VERY DELICATE GROUND”")])]), _vm._v(" "), _c('p', {
    staticClass: "C119"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Afterwor#page_239",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("AFTERWORD")])]), _vm._v(" "), _c('p', {
    staticClass: "C144"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Afterwor#page_239",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pride or Self-Effacement: On Refusing to Save Skin")])])]), _vm._v(" "), _c('p', {
    staticClass: "C119"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Index#page_243",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("INDEX")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-942657b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_Contents.vue
// module id = 69
// module chunks = 0